export default [
    {
        path: '/percurso-formativo',
        name: 'learning-path',
        component: () => import('./views/LearningPathPage.vue'),
        meta: {
            title: 'Percurso Formativo',
            icon: 'mdi-school-outline',
            breadcrumbs: [
                { text: 'Acadêmico', disabled: true, href: '/' },
                { text: 'Percurso Formativo', disabled: true, href: '/' },
            ],
        },
    },
]
